/// <reference path="/js/lib/jquery/jquery-1.9.1.js"/>
/// <reference path="/js/lib/backbone.js"/>
/// <reference path="~/js/viz/shared/views/SelectorsView.js"/>

(function($, _) {
  var ns, selectorNs, sharedNs;

  ns = window.nspace("ccc.viz.bar.views");
  selectorNs = window.nspace("ccc.viz.selectors");
  sharedNs = window.nspace("ccc.viz.shared");

  ns.SelectorsView = sharedNs.views.SelectorsView.extend({
    initializeView: function() {
      // Expose this (presumably one-and-only) instance globally so that other components
      // can call "public" methods and get selector information, such as for building data summaries.
      // TODO: What's a better way to architect this?
      ns.instances = { SelectorsView: this };

      this.model.on("change", this.updateDataSummary);
    },

    initializeSelectors: function() {
      this.allSelectors = [
        // Breakdown
        (this.breakdownSelectorView = new selectorNs.MultipleBreakdownSelectorView(
          {
            model: this.model
          }
        )),
        // Location
        (this.locationSelectorView = new selectorNs.LocationSelectorView({
          model: this.model
        })),
        // Data Type
        (this.dataTypeSelectorView = new selectorNs.DataTypeSelectorView({
          model: this.model,
          getSelectorInfoFunc: this.getSelectorInfoOrThrow
        })),
        // TimeFrame
        (this.timeFrameSelectorView = new selectorNs.TimeFrameSelectorView({
          model: this.model,
          getSelectorInfoFunc: this.getSelectorInfoOrThrow
        }))
      ];
    },

    getIndicatorSpecificSelectors: function() {
      return [this.dataTypeSelectorView, this.timeFrameSelectorView];
    },

    updateDataSummary: function() {
      $("#data-summary").text(this.getDataSummary());
    },

    renderSelectors: function(selectorInfo) {
      var indicatorSpecificSelectors, indicatorSelectorInfo;

      // Selectors that are specific to a single indicator. This is all selectors
      // besides the breakdown selector.
      indicatorSpecificSelectors = this.getIndicatorSpecificSelectors();

      // Breakdown selector
      this.breakdownSelectorView.render(selectorInfo);

      // The other selectors all expect indicator-specific selector info
      indicatorSelectorInfo =
        selectorInfo.selectors[this.model.get("indicatorId")];
      for (var i = 0; i < indicatorSpecificSelectors.length; i++) {
        // Render the selector
        indicatorSpecificSelectors[i].render(indicatorSelectorInfo);
      }

      var info = this.shapeLocations(selectorInfo, indicatorSelectorInfo);
      // Location selector
      this.locationSelectorView.render(info);
    },

    shapeLocations: function(selectorInfo, indicatorSelectorInfo) {
      var orphanLocations, locationTypes;

      locationTypes = _(indicatorSelectorInfo.locationTypes)
        .sortBy(function(locationType) {
          return locationType.displayOrder;
        })
        .value();

      orphanLocations = _(selectorInfo.locations)
        .filter(function(location) {
          return !location.parent;
        })
        .value();

      _.each(locationTypes, function(locationType) {
        locationType.locations = _(selectorInfo.locations)
          .filter(function(location) {
            return !!location.parent && location.parent.id === locationType.id;
          })
          .sortBy(function(location) {
            return location.name;
          })
          .value();
      });

      return {
        orphanLocations: orphanLocations,
        locationTypes: locationTypes
      };
    }
  });
})(jQuery, _);
